import React, { useEffect, useState } from 'react';
import "../home/home.css";
import image1 from "../../Assets/construction-site.jpg";
import image2 from "../../Assets/oil-gas-project.jpg";
import image3 from "../../Assets/airports.jpg";
import image4 from "../../Assets/hospitals.jpg";
import image5 from "../../Assets/hotels.jpg";
import image6 from "../../Assets/traffic-areas.jpg";
import image7 from "../../Assets/road-rail-projects.jpg";
import image8 from "../../Assets/sports-events.jpg";
import image9 from "../../Assets/generator-rooms.jpg";
import diamond from '../../Assets/bg-diamond-af.png';
import cornerimg from '../../Assets/image-decor-corner.svg';
import screening from '../../Assets/screening.jpeg';
import { IoIosArrowRoundForward } from "react-icons/io";
import logo from '../../Assets/LOGO.png';
import refbarrier from '../../Assets/sound-barrier-manufacturer.webp';
import featbarrier from '../../Assets/sound-barrier-india.webp';
import rightimg from '../../Assets/sound-barrier-header-new (5).png';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { Link } from 'react-router-dom';


function Home() {
    const [showTopBtn, setShowTopBtn] = useState(false);

    useEffect(() => {
        const sections = document.querySelectorAll('section[id]');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const sectionId = entry.target.id;
                        let newHash = '#';
                        if (sectionId !== 'home') {
                            newHash += sectionId;
                        }
                        window.history.replaceState(null, '', newHash);
                    }
                });
            },
            {
                root: null,
                threshold: 0.3
            }
        );

        sections.forEach(section => observer.observe(section));

        return () => {
            sections.forEach(section => observer.unobserve(section));
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        };
        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const animatedElements = document.querySelectorAll('.home-title,.home-title2,.screen-title,.feat-title, .feat-title2,.app-title, .ziczac,.contact-title,.contact-title2,.ziczas');

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, { threshold: 0.3 });

        animatedElements.forEach(el => observer.observe(el));

        return () => {
            animatedElements.forEach(el => observer.unobserve(el));
        };
    }, []);

    const handleClick = () => {
        const name = document.getElementById('name').value.trim();
        const mail = document.getElementById('mail').value.trim();
        const phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();

        const subject = `New message from ${name}`
        const body = `Name: ${name}%0AEmail: ${mail}%0APhone: ${phone}%0A%0AMessage:%0A${message}`;
        const mailtoLink = `mailto:mail@acousticalsurfaces.in?subject=${encodeURIComponent(subject)}&body=${body}`;

        window.open(mailtoLink, '_blank');

        document.getElementById('name').value = '';
        document.getElementById('mail').value = '';
        document.getElementById('phone').value = '';
        document.getElementById('message').value = '';
    }

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Sound Barrier or Noise Barrier Manufacturer from India</title>
                    <meta name="description" content="We are a Noise Barriers Manufacturer from India. We offer all types of barriers that provide excellent noise control for a variety of situations and applications." />
                    <meta name="robots" content="index, follow" />
                    <meta name="geo.placename" content="India" />
                    <meta http-equiv="content-language" content="in" />
                    <meta name="geo.region" content="india" />
                    <meta property="og:title" content="Sound Barrier Products" />
                    <meta property="og:description" content="We offer all types of barriers that provide excellent noise control for a variety of situations and applications." />
                    <meta property="og:image" content="https://www.soundbarrier.in/static/media/sound-barrier.26f7aa05ba62d7c8c6a3.png" />
                    <meta property="og:locale" content="en-in" />
                    <link rel="alternate" href="https://www.soundbarrier.in/" hreflang="en-in" />
                    <link rel="canonical" href="https://www.soundbarrier.in/" />
                </Helmet>
            </HelmetProvider>

            <section id='home' className='home' style={{ backgroundColor: "#808080" }}>
                <div className="container">
                    <div className='content-right'>
                        <img className='logo-img' src={logo} alt="sound-barrier-logo" />
                        <p className='home-para'>
                            Scientifically Designed for Real-World Noise Control
                            In modern noise control engineering, one of the most effective ways to reduce noise is by interrupting its transmission path. When source modification is impractical such as with construction equipment, generators, or heavy machinery acoustic barriers become essential. Our Sound Barrier operates using scientifically proven acoustic principles of blocking, absorbing, and diffusing sound energy in outdoor and semi-reverberant environments.
                        </p>
                    </div>
                    <div>
                        <img className="img-fluid right-img" src={rightimg} alt="" />
                    </div>

                    <div id="googleMap"></div>

                    {/* <div className="small-circle">
                        <span></span>
                    </div> */}

                    <svg
                        version="1.1"
                        id="radar-svg"
                        pointerEvents="none"
                    >
                        <polygon
                            id="radar-beam"
                            fill="#ED1C24"
                            points=""
                            fillOpacity={0.75}
                        />
                    </svg>

                    <svg
                        version="1.1"
                        id="radar-circle-other"
                        pointerEvents="none"
                    >
                        <circle
                            cx="10%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="16px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="0.25s" />
                        </circle>

                        <circle
                            cx="10%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="12px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="1.25s" />
                        </circle>

                        <circle
                            cx="10%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="8px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="2.25s" />
                        </circle>

                        <circle
                            cx="10%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="4px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="3.25s" />
                        </circle>

                        <circle
                            cx="10%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="2px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="4.25s" />
                        </circle>
                        <circle
                            cx="10%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="2px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="5.25s" />
                        </circle>
                    </svg>
                </div>
            </section>


            <section id='acoustic-science'>
                <div className='container'>
                    <h1 className='screen-title'>How It Works</h1>
                    <p className='app-para'>Acoustic Science Behind the Design</p>
                    <div className='row d-flex align-items-center'>
                        <div className='col-12 col-md-6'>
                            <img src={screening} alt="screening" style={{ height: "400px", width: "100%" }} />
                        </div>
                        <div className='col-12 col-md-6'>
                            <h4>1. Sound Insulation (Blocking via Mass Law)</h4>
                            <p className='inner-para'>
                                The barrier incorporates a dense, mass-loaded core layered between weather-resistant membranes. This design follows the Mass Law Principle, where increased surface density provides higher resistance to airborne sound transmission, particularly effective in reducing mid to high-frequency noise (e.g., 500–5000 Hz).
                            </p>
                            <p className='inner-para'>Lab-tested STC rating: 19</p>
                            <p className='inner-para'> Reduction: Up to 51 dB at 5000 Hz</p>
                        </div>
                        <h4>2. Sound Absorption (Dissipation of Acoustic Energy)</h4>
                        <p className='inner-para'>
                            Inside the barrier is a layer of acoustic infill, made of fibrous or porous material. This material acts as a dissipative medium, converting incident sound energy into heat through friction. It reduces sound reflections in semi-reverberant spaces and improves speech intelligibility and comfort.
                        </p>
                        <h4>3. Sound Diffraction (Creating an Acoustic Shadow)</h4>
                        <p className='inner-para'>
                            Positioned between the noise source and the receiver, the barrier forms a partial enclosure or a screen, interrupting the direct path of sound. According to Maekawa’s theory, the degree of attenuation depends on the path difference (δ) between the direct sound line and the shortest path over the barrier.
                        </p>
                        <p className='inner-para'>Greater path difference (δ) → Higher insertion loss</p>
                        <p className='inner-para'>High-frequency sounds (shorter wavelengths) are effectively blocked</p>
                        <p className='inner-para'>Low-frequency sounds are more likely to diffract around the edges</p>
                        <p className='inner-para'>In ideal outdoor conditions, the barrier can achieve up to 10–15 dBA reduction behind the panel.</p>
                    </div>
                </div>
            </section>

            <section id='application'>
                <div className='application-wrapper'>
                    <div className='container'>
                        <h2 className='app-title'>Applications</h2>
                        <p className='app-para'> Designed for Compliance. Built for Performance.
                            Backed by independent lab testing and aligned with ISO and ASTM standards, our Sound Barrier system offers an effective, adaptable, and certified solution for real-world noise control. Whether deployed on a construction site or around industrial equipment, it ensures compliance, protects the environment, and promotes occupational health and comfort.</p>

                        <div className='app-gallery container'>
                            <div className='row mt-5'>
                                <div className='col-12 col-sm-6 col-md-4 mb-4'>
                                    <div className='position-relative d-inline-block'>
                                        <img src={image1} alt="Construction sites" className='img-fluid rounded' />
                                        <img className='corner-img img-fluid' src={cornerimg} alt="corner" />
                                    </div>
                                    <p className="img-content mt-2">Construction sites</p>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 mb-4'>
                                    <div className='position-relative d-inline-block'>
                                        <img src={image2} alt="Oil & Gas projects" className='img-fluid rounded' />
                                        <img className='corner-img img-fluid' src={cornerimg} alt="corner" />
                                    </div>
                                    <p className="img-content mt-2">Oil & Gas projects</p>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 mb-4'>
                                    <div className='position-relative d-inline-block'>
                                        <img src={image3} alt="Airports" className='img-fluid rounded' />
                                        <img className='corner-img img-fluid' src={cornerimg} alt="corner" />
                                    </div>
                                    <p className="img-content mt-2">Airports</p>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 mb-4'>
                                    <div className='position-relative d-inline-block'>
                                        <img src={image4} alt="img-1" className='img-fluid rounded' />
                                        <img className='corner-img img-fluid' src={cornerimg} alt="corner" />
                                    </div>
                                    <p className="img-content mt-2">Hospitals</p>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 mb-4'>
                                    <div className='position-relative d-inline-block'>
                                        <img src={image5} alt="img-2" className='img-fluid rounded' />
                                        <img className='corner-img img-fluid' src={cornerimg} alt="corner" />
                                    </div>
                                    <p className="img-content mt-2">Hotels</p>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 mb-4'>
                                    <div className='position-relative d-inline-block'>
                                        <img src={image6} alt="img-3" className='img-fluid rounded' />
                                        <img className='corner-img img-fluid' src={cornerimg} alt="corner" />
                                    </div>
                                    <p className="img-content mt-2">Traffic areas</p>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 mb-4'>
                                    <div className='position-relative d-inline-block'>
                                        <img src={image7} alt="img-1" className='img-fluid rounded' />
                                        <img className='corner-img img-fluid' src={cornerimg} alt="corner" />
                                    </div>
                                    <p className="img-content mt-2">Road & Rail Projects</p>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 mb-4'>
                                    <div className='position-relative d-inline-block'>
                                        <img src={image8} alt="img-2" className='img-fluid rounded' />
                                        <img className='corner-img img-fluid' src={cornerimg} alt="corner" />
                                    </div>
                                    <p className="img-content mt-2">Sports events</p>
                                </div>
                                <div className='col-12 col-sm-6 col-md-4 mb-4'>
                                    <div className='position-relative d-inline-block'>
                                        <img src={image9} alt="img-3" className='img-fluid rounded' />
                                        <img className='corner-img img-fluid' src={cornerimg} alt="corner" />
                                    </div>
                                    <p className="img-content mt-2">Generator rooms</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id='product-features'>
                <div className='product-feat'>
                    <div className='bg-shape'>
                        <img className='img-fluid diamond' src={diamond} alt="star" />
                    </div>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-6'>
                                <h2 className='feat-title'>product</h2>
                                <h2 className='feat-title2'>Features</h2>
                                <p className='app-para mt-3'>Sound Barriers are mainly used in the construction site, help to prevent noise propagation to the neighborhood and reduce work area noise. It not only provides workers with better working environment, but also avoids complaints from nearby residents especially when your project is in the center of city.</p>
                                <h3 className='tech-title mt-2'>Technical Specifications</h3>
                                <ul className='list mt-4'>
                                    <li className='inner-para'>Noise reduction : Upto 51dB reduction (at 5000Hz)</li>
                                    <li className='inner-para'>Height : 2060mm</li>
                                    <li className='inner-para'>Width : 1350mm</li>
                                    <li className='inner-para'>Fire Retardancy : As per ASTM E84</li>
                                    <li className='inner-para'>Water resistance : Water proof membrane and acoustic infill are used.</li>
                                    <li className='inner-para'>Warranty : 2 years</li>
                                    <li className='inner-para'>Colors : Multi colors available upon request</li>
                                    <li className='inner-para'>Road safety : Multiple reflective bands</li>
                                </ul>
                            </div>
                            <div className='col-md-6 d-flex justify-content-center align-items-center'>
                                <img className='sound-b-img' src={refbarrier} alt="sound barrier-img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id='references'>
                <div className='container mt-5'>
                    <div className='row'>
                        <div className='col-12 col-md-6 order-2 order-md-1'>
                            <div className="svg-container">
                                <img className='img-fluid' src={featbarrier} alt="refbarrier" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 order-1 order-md-2'>
                            <p className='inner-para'>The development and validation of our Sound Barrier system are guided by a combination of in-house acoustic testing, third-party laboratory certification, and international standards, supplemented by foundational acoustic theory and current engineering best practices.</p>
                            <p className='inner-para'>Initial quality control is performed at our in-house testing lab, where we evaluate material density, acoustic absorption consistency, and mechanical integrity. Full-scale performance is certified through independent tests conducted by ARAI (Automotive Research Association of India), in compliance with industry-recognized protocols.</p>
                            <h4>International Standards and Test Protocols</h4>
                            <p className='inner-para'><span><IoIosArrowRoundForward className='arrow-icon' /></span> ISO 10140-2: Acoustics – Laboratory measurement of airborne sound insulation of building elements</p>
                            <p className='inner-para'><span><IoIosArrowRoundForward className='arrow-icon' /></span> ISO 717-1: Rating of sound insulation in buildings and of building elements – Airborne sound insulation</p>
                            <p className='inner-para'><span><IoIosArrowRoundForward className='arrow-icon' /></span> ISO 9613-2: Attenuation of sound during propagation outdoors – General method of calculation</p>
                            <p className='inner-para'><span><IoIosArrowRoundForward className='arrow-icon' /></span> ISO 354: Measurement of sound absorption in a reverberation room</p>
                            <p className='inner-para'><span><IoIosArrowRoundForward className='arrow-icon' /></span> ASTM E90: Standard Test Method for Laboratory Measurement of Airborne Sound Transmission Loss of Building Partitions</p>
                            <p className='inner-para'><span><IoIosArrowRoundForward className='arrow-icon' /></span> ASTM E413: Classification for Rating Sound Insulation</p>
                            <p className='inner-para'><span><IoIosArrowRoundForward className='arrow-icon' /></span> ASTM C423: Sound Absorption and Sound Absorption Coefficients by the Reverberation Room Method</p>
                            <p className='inner-para'><span><IoIosArrowRoundForward className='arrow-icon' /></span> ASTM E84: Standard Test Method for Surface Burning Characteristics of Building Materials</p>
                            <h4>Research Studies and Acoustic Engineering Models</h4>
                            <p className='inner-para'><span><IoIosArrowRoundForward className='arrow-icon' /></span> Maekawa, Z. (1968). Noise Reduction by Screens, Applied Acoustics, Vol. 1, Issue 3.</p>
                            <p className='inner-para'><span><IoIosArrowRoundForward className='arrow-icon' /></span> Kurze, U. J., & Anderson, G. S. (1971). Sound Propagation Outdoors. Applied Acoustics.</p>
                            <p className='inner-para'><span><IoIosArrowRoundForward className='arrow-icon' /></span> Harris, Cyril M. (Ed.). (1991). Handbook of Acoustical Measurements and Noise Control, McGraw-Hill.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section id='contact-us'>
                <div className="contact-background">

                    <div id="googleMap"></div>
                    <svg
                        version="1.1"
                        id="radar-svg"
                        pointerEvents="none"
                    >
                        <polygon
                            id="radar-beam"
                            fill="#ED1C24"
                            points=""
                            fillOpacity={0.75}
                        />
                    </svg>

                    <svg
                        version="1.1"
                        id="radar-circle-other"
                        pointerEvents="none"
                    >
                        <circle
                            cx="100%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="16px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="0.25s" />
                        </circle>

                        <circle
                            cx="100%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="12px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="1.25s" />
                        </circle>

                        <circle
                            cx="100%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="8px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="2.25s" />
                        </circle>

                        <circle
                            cx="100%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="4px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="3.25s" />
                        </circle>

                        <circle
                            cx="100%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="2px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="4.25s" />
                        </circle>
                        <circle
                            cx="100%"
                            cy="100%"
                            r="0"
                            fillOpacity="0"
                            stroke="white"
                            strokeWidth="2px"
                            strokeOpacity="0.4"
                        >
                            <animate attributeName="r" from="0" to="1220" dur="6s" repeatCount="indefinite" begin="5.25s" />
                        </circle>
                    </svg>
                    <div className="container" style={{ marginTop: "100px", marginBottom: "70px" }}>
                        <h2 className="contact-title">Quotes &</h2>
                        <h2 className="contact-title2">Contact</h2>
                        <p className="contact-content">
                            Need privacy from noisy neighbours? <br />
                            Contact us today!
                        </p>

                        <div className="contact-form mt-5">
                            <form>
                                <div className="row">
                                    {/* Form Section */}
                                    <div className="col-md-6 mt-3">
                                        <div className="row">
                                            <div className="col-sm-12 col-md-4 mb-3">
                                                <input
                                                    type="text"
                                                    name="name"
                                                    id="name"
                                                    className="form-control"
                                                    placeholder="Name *"
                                                />
                                            </div>
                                            <div className="col-sm-12 col-md-4 mb-3">
                                                <input
                                                    type="email"
                                                    name="mail"
                                                    id="mail"
                                                    className="form-control"
                                                    placeholder="Email *"
                                                />
                                            </div>
                                            <div className="col-sm-12 col-md-4 mb-3">
                                                <input
                                                    type="text"
                                                    name="phone"
                                                    id="phone"
                                                    className="form-control"
                                                    placeholder="Phone *"
                                                />
                                            </div>
                                            <div className="col-12 mb-3">
                                                <textarea
                                                    rows={4}
                                                    id="message"
                                                    className="form-control"
                                                    placeholder="Message *"
                                                ></textarea>
                                            </div>
                                            <div className="col-12">
                                                <button
                                                    className="btn"
                                                    type="button"
                                                    onClick={handleClick}
                                                >
                                                    SEND
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Address Section */}
                                    <div className="col-md-6 d-flex justify-content-center">
                                        <div className="text-start mb-5">
                                            <span className="cnt-span">
                                                Acoustical Surfaces Industries LLP.<br />
                                                130/2B, Morappampalayam,<br />
                                                Uppilipalayam (P.O), Karuvalur<br />
                                                Tirupur - 641670<br />
                                                Tamil Nadu, India <br />
                                                <b>Tel:</b>{" "}
                                                <a href="tel:+919449777212">+91-9449777212</a> |{" "}
                                                <a href="tel:+918277331000">+91-82773 31000</a>
                                                <br />
                                                <b>Mail:</b>{" "}
                                                <a
                                                    href="mailto:mail@acousticalsurfaces.in?subject=Inquiry&body=Hello, I would like to know more about your services."
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    mail@acousticalsurfaces.in
                                                </a>
                                                <Link className="float-button" target="_blank" to="https://wa.me/919449777212?text=Hi">
                                                    <i className="fa fa-whatsapp" aria-hidden="true" style={{ width: "17px", height: "18px" }}></i>
                                                    <span>Message me</span>
                                                </Link>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            {showTopBtn && (
                <button className='scroll-to-top'
                    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                > ↑ </button>
            )}
        </>
    )
}

export default Home